
const VrstaPosjete = function(DS) {
    return DS.defineResource({
        name: 'VrstaPosjete',
        endpoint: 'vrstePosjete'
    });
};

VrstaPosjete.$inject = ['DS'];


export {VrstaPosjete};



// WEBPACK FOOTER //
// ./app/models/vrstaPosjete.js